import type { ReactNode } from 'react';

export type RankTone = 'positive' | 'negative' | 'neutral';

const FILL_TONE: Record<RankTone, string> = {
  positive: 'bg-primary-ink',
  negative: 'bg-destructive',
  neutral: 'bg-muted-foreground',
};

const TRACK = 'h-track w-full rounded-pill bg-secondary';

export function RankRow(props: {
  label: string;
  value: ReactNode;
  share?: number;
  tone?: RankTone;
}): ReactNode {
  const { label, value, share, tone = 'neutral' } = props;
  const clampedShare = share !== undefined ? Math.min(Math.max(share, 0), 1) : undefined;

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-body-sm">{label}</span>
        <span data-numeric className="text-body-sm">
          {value}
        </span>
      </div>
      {clampedShare !== undefined ? (
        <div
          role="meter"
          aria-label={label}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={clampedShare * 100}
          className={TRACK}
        >
          <div
            data-slot="fill"
            className={`h-track rounded-pill ${FILL_TONE[tone]}`}
            style={{ width: `${clampedShare * 100}%` }}
          />
        </div>
      ) : (
        <div className={TRACK} />
      )}
    </div>
  );
}
